export type IframeStyles = Record<string, Record<string, string>>;

export const ifsStyles: IframeStyles = {
  input: {
    'font-size': '14px',
    color: '#374151',
    'font-family': 'Sparkasse Rg, Helvetica, sans-serif',
  },
  '.ifs-focused': {
    outline: '3px solid #8622ce !important',
  },
  '.ifs-invalid': {
    color: '#f87c7c',
  },
};
